import L from "leaflet";
import {
  getLocationGroupOffset,
  mapCoordinate
} from "../../util/helper/helperFunctions";

export const prodLineCoordinateConverter = (data, prodLinesJSON, mapObject) => {
  const coordConvertedData = data.map((prodLine) => {
    const convertedCoordinates = mapCoordinate(
      prodLine["LONGITUDE"],
      prodLine["LATITUDE"],
      "lines",
      prodLinesJSON.bounds
    );
    const convertedPoints = L.point(
      convertedCoordinates.x - prodLinesJSON.groupOffset.x,
      convertedCoordinates.y - prodLinesJSON.groupOffset.y
    );
    const convertedLatLng =
      mapObject.map.target.layerPointToLatLng(convertedPoints);

    return {
      ...prodLine,
      currentPos: {
        lat: convertedLatLng.lat,
        lng: convertedLatLng.lng
      }
    };
  });

  return coordConvertedData;
};

export const battStationCoordinateConverter = (
  data,
  battStationsJSON,
  mapObject
) => {
  const coordConvertedData = data.map((battStation) => {
    const convertedCoordinates = mapCoordinate(
      battStation["longitude"],
      battStation["latitude"],
      "battery",
      battStationsJSON.bounds
    );
    const convertedPoints = L.point(
      convertedCoordinates.x - battStationsJSON.groupOffset.x,
      convertedCoordinates.y - battStationsJSON.groupOffset.y
    );
    const convertedLatLng =
      mapObject.map.target.layerPointToLatLng(convertedPoints);

    return {
      ...battStation,
      currentPos: {
        lat: convertedLatLng.lat,
        lng: convertedLatLng.lng
      }
    };
  });

  return coordConvertedData;
};

export const dockDoorCoordinateConverter = (data, dockDoorsJSON, mapObject) => {
  const coordConvertedData = data.map((dockDoor) => {
    const convertedCoordinates = mapCoordinate(
      dockDoor[0]["longitude"],
      dockDoor[0]["latitude"],
      "dockdoors",
      dockDoorsJSON.bounds
    );
    const convertedPoints = L.point(
      convertedCoordinates.x + dockDoorsJSON.groupOffset.x,
      convertedCoordinates.y + dockDoorsJSON.groupOffset.y
    );
    const convertedLatLng =
      mapObject.map.target.layerPointToLatLng(convertedPoints);

    const updatedDockDoor = dockDoor.map((pallet) => ({
      ...pallet,
      currentPos: {
        lat: convertedLatLng.lat,
        lng: convertedLatLng.lng
      }
    }));

    return updatedDockDoor;
  });
  return coordConvertedData;
};

export const nonLGVCoordinateConverter = (nonLGVJSON, mapObject) => {
  const convertedStart = L.point(
    nonLGVJSON.coordinate.x,
    nonLGVJSON.coordinate.y,
    "lgv"
  );
  const convertedLatLng =
    mapObject.map.target.layerPointToLatLng(convertedStart);
  const convertedPositionObj = getLocationGroupOffset(convertedLatLng, {
    x: 0,
    y: 0
  });
  return convertedPositionObj;
};

export const blockStorageCoordinateConverter = ({
  latitude,
  longitude,
  location,
  locationOrientation,
  positionLength,
  blockStorageConfig,
  mapObject
}) => {
  let convertedStart;
  let convertedPoints;
  let convertedLatLng;
  let convertedPositionObj;

  const { bounds, eachItemOffset, eastLocationOffset, westLocationOffset } =
    blockStorageConfig;

  if (locationOrientation === "E") {
    //Send the Block bounds to Coordinate Converter
    convertedStart = mapCoordinate(
      longitude - positionLength,
      latitude,
      "block",
      bounds
    );
    //Convert the X and Y to Lat and Lng
    convertedPoints = L.point(convertedStart.x, convertedStart.y);
    convertedLatLng = mapObject.map.target.layerPointToLatLng(convertedPoints);
    //Set the location Offset
    if (eachItemOffset[location]) {
      let offset = eachItemOffset[location];
      convertedPositionObj = getLocationGroupOffset(convertedLatLng, offset);
    } else {
      convertedPositionObj = getLocationGroupOffset(
        convertedLatLng,
        eastLocationOffset
      );
    }
  } else {
    //West or South Location Blocks
    convertedStart = mapCoordinate(longitude, latitude, "block", bounds);
    //Convert the X and Y to Lat and Lng
    convertedPoints = L.point(convertedStart.x, convertedStart.y);
    convertedLatLng = mapObject.map.target.layerPointToLatLng(convertedPoints);
    if (eachItemOffset[location]) {
      let offset = eachItemOffset[location];
      convertedPositionObj = getLocationGroupOffset(convertedLatLng, offset);
    } else {
      convertedPositionObj = getLocationGroupOffset(
        convertedLatLng,
        westLocationOffset
      );
    }
  }

  return convertedPositionObj;
};

export const rackStorageCoordinateConverter = ({
  latitude,
  longitude,
  location,
  rackStorageConfig,
  mapObject
}) => {
  let convertedStart;
  let convertedPoints;
  let convertedLatLng;
  let convertedPositionObj;

  //Get Rack Details from Config

  const { bounds, eachItemOffset, groupOffset } = rackStorageConfig;

  //Send the Rack bounds to Coordinate Converter
  convertedStart = mapCoordinate(longitude, latitude, "rack", bounds);
  convertedPoints = L.point(convertedStart.x, convertedStart.y);
  convertedLatLng = mapObject.map.target.layerPointToLatLng(convertedPoints);

  //Convert X and Y to Lat and Lng
  if (eachItemOffset[location]) {
    let offset = eachItemOffset[location];
    convertedPositionObj = getLocationGroupOffset(convertedLatLng, offset);
  } else {
    convertedPositionObj = getLocationGroupOffset(convertedLatLng, groupOffset);
  }

  return convertedPositionObj;
};
